import { Inject, Injectable } from '@angular/core';

import { EditorView } from 'prosemirror-view';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { cachedStringSearch } from '@core/symbol-data';
import { includesWithTrim } from '@core/utils-legacy';

import { MentionServiceInternal } from '../mentions-service-internal';
import { MENTION_STRATEGY_TOKEN } from '../tokens';
import type { MentionElement, MentionListController, MentionsPluginEvents } from '../types';

@Injectable()
export class MentionServiceInternalDefault extends MentionServiceInternal {
  public data: MentionElement[];
  public filterData = cachedStringSearch<MentionElement>(query =>
    this.data.filter(item => includesWithTrim(item.name, query, { trim: false })),
  );
  constructor(
    protected editorView: EditorView,
    private dataSource: Observable<MentionElement[]>,
    protected eventStream$: Subject<MentionsPluginEvents>,
    private scroll$: Observable<void>,
    private destroy$: Observable<void>,
    @Inject(MENTION_STRATEGY_TOKEN)
    protected mentionListController?: MentionListController,
  ) {
    super(editorView, eventStream$, mentionListController);
    if (this.mentionListController) {
      this.mentionListController.registerRestoreFocus(() => this.editorView.focus());

      this.dataSource.pipe(takeUntil(this.destroy$)).subscribe(data => {
        this.data = data.sort((a, b) => a.name.localeCompare(b.name));

        if (!this.mentionListController!.isOpen()) return;

        const filteredData = this.filterData(this.currentQuery);
        this.mentionListController!.setData(filteredData);
      });

      this.scroll$.pipe(takeUntil(this.destroy$)).subscribe(() => {
        if (!this.mentionListController!.isOpen()) return;

        const position = this.getPositionFromCurrentOrigin();
        this.mentionListController!.updatePosition(position);
      });
    }
  }
}
